import {useContext} from 'react';
import {useRouteMatch} from 'react-router-dom';
import {InviteSenderType} from '../../../../../../../backend/enums/invite-sender-type';
import {ProfessionalCaregiverInviteForm} from '../../../../../../../components/professional-caregiver-invite-form/professional-caregiver-invite-form';
import {AuthContext} from '../../../../../../../contexts/auth/context';
import {AuthContextType} from '../../../../../../../contexts/auth/types';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {ProfessionalCaregiverInviteFormType} from '../../../../../../../enums/professional-caregiver-invite-form-type';

export default function EntityInviteProfessionalCaregiverSystemAdministratorOfficeScreen() {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);
  const officeContext: OfficeContextType = useContext(OfficeContext);

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <ProfessionalCaregiverInviteForm
      formType={ProfessionalCaregiverInviteFormType.SystemAdministrator}
      senderType={InviteSenderType.System}
      senderId={authContext.state.session?.id || ''}
      entity={{
        entityId: officeContext.state.entityForm?.id || '',
        entityName: officeContext.state.entityForm?.name || '',
      }}
      redirectUrl={`${url.replace('/invite', '')}`}
      showExitButton={false}
      useSmallerTitle={true}
    />
  );
}
